/* Packages */
import React from 'react';
import { hydrate } from 'react-dom';

/* Components */
import ProductViewTrack from './components/ProductViewTrack';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productSearchNodes = Array.from(document.querySelectorAll('.product-view-track'));
[...productSearchNodes].forEach((node) => hydrate(<ProductViewTrack {...parseDataToProps(node.dataset)} />, node));
